import { create } from 'zustand';

export type ReviewStore = {
  reviewId: string | null;
  reviewType: 'auth' | 'not-auth' | null;
  setReviewId: (reviewId: string) => void;
  setReviewType: (reviewType: 'auth' | 'not-auth') => void;
};

export const useReviewStore = create<ReviewStore>((set, get) => ({
  reviewId: null,
  reviewType: null,
  setReviewId: (reviewId: string) => set({ reviewId }),
  setReviewType: (reviewType: 'auth' | 'not-auth') => set({ reviewType }),
}));
